import React, { useRef } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import Card from '../../../../molecules/Card'
import InlineCardHeader from '../../../../molecules/Card/InlineCardHeader'
import SydButton from '../../../../commonDesign/Button'
import EditDatapointDialog from '../dialogs/EditDatapointDialog'
import DescribeDatapointDialog from '../dialogs/DescribeDatapointDialog'
import FlexRow from '../../../../molecules/FlexRow'
import ChangeDatasourceSchemaDialog from '../dialogs/ChangeDatasourceSchemaDialog'
import ChangeDatasourceCodeDialog from '../dialogs/ChangeDatasourceCodeDialog'
import DataSourceAttributes from './DatasourceAttributes'
import DatapointsTable from './DatapointsTable'
import DatasourceDescription from './DatasourceDescription'

function DetailsTab ({ datasource }) {
  const editDatapointsRef = useRef(null)
  const describeDatapointDialog = useRef(null)
  const changeDatasourceSchemaDialog = useRef(null)
  const changeDatasourceCodeDialog = useRef(null)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader>Details</InlineCardHeader>
          <DataSourceAttributes datasource={datasource} />
          <FlexRow>
            <SydButton size='sm' onClick={() => changeDatasourceSchemaDialog.current.open(datasource)}>Change Schema</SydButton>
            <SydButton size='sm' onClick={() => changeDatasourceCodeDialog.current.open(datasource)}>Change Code</SydButton>
          </FlexRow>
          <ChangeDatasourceSchemaDialog ref={changeDatasourceSchemaDialog} />
          <ChangeDatasourceCodeDialog ref={changeDatasourceCodeDialog} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader>Description</InlineCardHeader>
          <DatasourceDescription datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <InlineCardHeader action={<SydButton size='sm' icon='edit' onClick={() => editDatapointsRef.current.open(datasource)}>Edit</SydButton>}>Datapoints</InlineCardHeader>
          <DatapointsTable datapoints={datasource.datapoints} onAccessorClick={(dp) => describeDatapointDialog.current.open(datasource, dp)} />
          <EditDatapointDialog ref={editDatapointsRef} />
          <DescribeDatapointDialog ref={describeDatapointDialog} />
        </Card>
      </Grid>
    </Grid>
  )
}

DetailsTab.propTypes = {
  datasource: PropTypes.any
}

export default DetailsTab
